import React from 'react';
import styled from 'styled-components';

import { CampaignType } from 'src/actions/campaigns/campaignsResource';
import { campaignTypeToEndpointType } from 'src/presentation/components/pages/proactiveCommunications/constants';
import EndpointsDropdown from 'src/presentation/components/pages/proactiveCommunications/components/shared/EndpointsDropdown';
import Input, { InputType } from 'src/presentation/components/forms/Input';
import IvrDropdown from 'src/presentation/components/pages/proactiveCommunications/components/shared/IvrDropdown';

import { Row } from 'src/presentation/components/forms/Layout';

const VoiceCampaignContentEditor = () => {
  return (
    <>
      <Row>
        <EndpointsDropdown
          data-aid="campaigns-endpoint-dropdown"
          attr="content.endpointId"
          tooltipMessage="The number used to make outbound calls."
          label="Phone number"
          placeholder="Select a phone number"
          endpointType={campaignTypeToEndpointType[CampaignType.VOICE]}
          description="The number used to make outbound calls."
        />
      </Row>
      <Row>
        <IvrDropdown attr="content.ivrId" placeholder="Select an IVR" description="The IVR for your Campaign." />
      </Row>
      <Row>
        <SimultaneousCallsInput
          data-aid="campaigns-simultaneous-calls-input"
          attr="content.concurrency"
          type={InputType.number}
          label="Simultaneous calls"
          placeholder="1-30"
          maxLength={3}
          description="The number of recipients to call at the same time. A lower number means lower call volumes for agents to take. A higher number means possibly higher call volumes."
        />
      </Row>
    </>
  );
};

export default VoiceCampaignContentEditor;

const SimultaneousCallsInput = styled(Input)`
  max-width: 48px;
`;
